var RegionLink = function($context) {
    var self = this;

    var classMap = {
        active: "pcg-area__item--active",
    };

    var active = (isActive) => {
        $context.toggleClass(classMap.active, isActive);
    };

    this.onMouseout = (eventData) => {
        if(eventData.id === self.id) {
            active(false);
        }
    };

    this.onMouseover = (eventData) => {
        if(eventData.id === self.id) {
            active(true);
        }
    };

    var bindEvents = () => {
        $.pcg.frontend.eventBusService.subscribe("region/mouseover", self.onMouseover);
        $.pcg.frontend.eventBusService.subscribe("region/mouseout", self.onMouseout);

        $context.on("mouseover", () => $.pcg.frontend.eventBusService.publish("region/mouseover", {
            id: self.id
        }));
        $context.on("mouseout", () => $.pcg.frontend.eventBusService.publish("region/mouseout", {
            id: self.id
        }));
    };

    Object.defineProperty(this, "id", {
        get: () => $context.data().hrfsRegion
    });

    bindEvents();

    Object.seal(self);

    return this;
};

module.exports = RegionLink;